import { render, staticRenderFns } from "./RequiredNutrientAlgorithm.vue?vue&type=template&id=e40d468a&scoped=true&lang=html&"
import script from "./RequiredNutrientAlgorithm.vue?vue&type=script&lang=js&"
export * from "./RequiredNutrientAlgorithm.vue?vue&type=script&lang=js&"
import style0 from "./RequiredNutrientAlgorithm.vue?vue&type=style&index=0&id=e40d468a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40d468a",
  null
  
)

export default component.exports